import { SystemDescriptions } from "src/common/descriptions";
import { formatToDisplayDatetime } from "src/common/util";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.USER.USERS
const commonDescriptions = SystemDescriptions.PAGES.COMMON

export enum ColumnsKeys {
    NO = 'key',
    NAME = 'name',
    SURNAME = 'surname',
    USERNAME = 'username',
    IS_ACTIVE = 'isActive',
    LAST_LOGIN = 'lastLogin',
    USER_ROLE = 'userRole',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.NAME,
        dataIndex: ColumnsKeys.NAME,
        key: ColumnsKeys.NAME,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.SURNAME,
        dataIndex: ColumnsKeys.SURNAME,
        key: ColumnsKeys.SURNAME,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.LAST_LOGIN,
        dataIndex: ColumnsKeys.LAST_LOGIN,
        key: ColumnsKeys.LAST_LOGIN,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value ? formatToDisplayDatetime(value) : "NA",
    },
    {
        title: descriptions.TABLE_COLUMNS.USER_ROLE,
        dataIndex: ColumnsKeys.USER_ROLE,
        key: ColumnsKeys.USER_ROLE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => {
            return dictionaryOfRoles[value]
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.STATUS,
        dataIndex: ColumnsKeys.IS_ACTIVE,
        key: ColumnsKeys.IS_ACTIVE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? commonDescriptions.ACTIVE_STATUS : commonDescriptions.INACTIVE_STATUS
    },
];

export const dictionaryOfRoles = {
    "ADMIN": descriptions.ROLES.ADMIN,
    "BASIC": descriptions.ROLES.MANAGER,
}